// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__LloYo","Open":"SideDrawer_Open__1YZ7L","Close":"SideDrawer_Close__94k8n","Logo":"SideDrawer_Logo__1x0YN"};